// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeLayout_layoutContainer__xTDkL {
  display: flex;
  justify-content: flex-end;
  min-height: 100vh;
}
.ThemeLayout_rtlDir__mOypM {
  direction: rtl;
  font-family: Estedad !important;
}
.ThemeLayout_ltrDir__Dvwt7 {
  direction: ltr;
  font-family: Inter !important;
  /* font-family: Estedad !important; */
}
.ThemeLayout_themeSidebarContainer__KLqvY {
  position: fixed;
  top: 20px;
  height: calc(100vh - 40px);
  z-index: 10001;
  display: flex;
  flex-direction: column;
}
.ThemeLayout_sidebarContainerRtlLan__fqE0g {
  right: 9px;
  transition: all 0.5s ease-out;
}
.ThemeLayout_sidebarContainerLtrLan__m9Upf {
  left: 9px;
  transition: all 0.5s ease-out;
}
.ThemeLayout_opSb__3UXUl {
  transform: translateX(0);
}
.ThemeLayout_rtlCl__GFVc- {
  transform: translateX(calc(100% - 8px));
}
.ThemeLayout_ltrCl__LN8v1 {
  transform: translateX(calc(-100% + 8px));
}
.ThemeLayout_mainContainer__INcS9 {
  transition: all 0.5s ease-out;
}
.ThemeLayout_openMainContainer__YpI8\\+ {
  width: calc(100% - 369px);
}
.ThemeLayout_closeMainContainer__Bxn6T {
  width: 100%;
}
.ThemeLayout_backDrop__sBs2r {
  display: none;
}

.ThemeLayout_privateSwip__ecsMr {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 15px;
  background-color: red;
  inset-inline-start: 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Edge, Opera and Firefox */
}

.ThemeLayout_whiteRootBackground__M3Q3W {
  /* background-color: #f5f5f5; */
  background-color: #fff;
}
.ThemeLayout_pinkRootBackground__R6NBB {
  background-color: #fff;
}
.ThemeLayout_gradientRootBackground__Kuuj7 {
  background-color: #fff;
}
.ThemeLayout_darkRootBackground__CpY48 {
  /* background-color: #fafafa; */
  background-color: #fff;
}
.ThemeLayout_BlueRootBackground__N-QVL {
  background-color: #fff;
}
.ThemeLayout_privateSwipOpen__G2Ss1 {
  z-index: 1;
}
.ThemeLayout_privateSwipClose__9x-Sj {
  z-index: 101;
}
.ThemeLayout_privateSwipBackDrop__bkToY {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.096);
  z-index: 102;
}
@media all and (max-width: 1700px) {
  .ThemeLayout_openMainContainer__YpI8\\+ {
    width: calc(100% - 339px);
  }
}
@media all and (max-width: 1500px) {
  .ThemeLayout_openMainContainer__YpI8\\+ {
    width: calc(100% - 319px);
  }
}
@media all and (max-width: 1400px) {
  .ThemeLayout_openMainContainer__YpI8\\+ {
    width: calc(100% - 304px);
  }
}
@media all and (max-width: 1300px) {
  .ThemeLayout_openMainContainer__YpI8\\+ {
    width: calc(100% - 299px);
  }
}
@media all and (max-width: 1100px) {
  .ThemeLayout_backDrop__sBs2r {
    position: fixed;
    display: block;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    z-index: 1001;
    background-color: rgba(50, 50, 50, 0.219);
  }
  .ThemeLayout_openMainContainer__YpI8\\+ {
    /* width: calc(100% - 25px); */
    width: 100%;
  }
}
@media all and (max-width: 400px) {
  .ThemeLayout_themeSidebarContainer__KLqvY {
    width: calc(100% - 18px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ThemeLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;EAClD,iBAAiB,EAAE;8EACyD;AAC9E;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,YAAY;AACd;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,eAAe;IACf,cAAc;IACd,MAAM;IACN,QAAQ;IACR,WAAW;IACX,aAAa;IACb,aAAa;IACb,yCAAyC;EAC3C;EACA;IACE,8BAA8B;IAC9B,WAAW;EACb;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".layoutContainer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  min-height: 100vh;\r\n}\r\n.rtlDir {\r\n  direction: rtl;\r\n  font-family: Estedad !important;\r\n}\r\n.ltrDir {\r\n  direction: ltr;\r\n  font-family: Inter !important;\r\n  /* font-family: Estedad !important; */\r\n}\r\n.themeSidebarContainer {\r\n  position: fixed;\r\n  top: 20px;\r\n  height: calc(100vh - 40px);\r\n  z-index: 10001;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.sidebarContainerRtlLan {\r\n  right: 9px;\r\n  transition: all 0.5s ease-out;\r\n}\r\n.sidebarContainerLtrLan {\r\n  left: 9px;\r\n  transition: all 0.5s ease-out;\r\n}\r\n.opSb {\r\n  transform: translateX(0);\r\n}\r\n.rtlCl {\r\n  transform: translateX(calc(100% - 8px));\r\n}\r\n.ltrCl {\r\n  transform: translateX(calc(-100% + 8px));\r\n}\r\n.mainContainer {\r\n  transition: all 0.5s ease-out;\r\n}\r\n.openMainContainer {\r\n  width: calc(100% - 369px);\r\n}\r\n.closeMainContainer {\r\n  width: 100%;\r\n}\r\n.backDrop {\r\n  display: none;\r\n}\r\n\r\n.privateSwip {\r\n  position: fixed;\r\n  top: 0;\r\n  height: 100vh;\r\n  width: 15px;\r\n  background-color: red;\r\n  inset-inline-start: 0;\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Safari */\r\n  -khtml-user-select: none; /* Konqueror HTML */\r\n  -moz-user-select: none; /* Old versions of Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none; /* Non-prefixed version, currently\r\n                                supported by Chrome, Edge, Opera and Firefox */\r\n}\r\n\r\n.whiteRootBackground {\r\n  /* background-color: #f5f5f5; */\r\n  background-color: #fff;\r\n}\r\n.pinkRootBackground {\r\n  background-color: #fff;\r\n}\r\n.gradientRootBackground {\r\n  background-color: #fff;\r\n}\r\n.darkRootBackground {\r\n  /* background-color: #fafafa; */\r\n  background-color: #fff;\r\n}\r\n.BlueRootBackground {\r\n  background-color: #fff;\r\n}\r\n.privateSwipOpen {\r\n  z-index: 1;\r\n}\r\n.privateSwipClose {\r\n  z-index: 101;\r\n}\r\n.privateSwipBackDrop {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.096);\r\n  z-index: 102;\r\n}\r\n@media all and (max-width: 1700px) {\r\n  .openMainContainer {\r\n    width: calc(100% - 339px);\r\n  }\r\n}\r\n@media all and (max-width: 1500px) {\r\n  .openMainContainer {\r\n    width: calc(100% - 319px);\r\n  }\r\n}\r\n@media all and (max-width: 1400px) {\r\n  .openMainContainer {\r\n    width: calc(100% - 304px);\r\n  }\r\n}\r\n@media all and (max-width: 1300px) {\r\n  .openMainContainer {\r\n    width: calc(100% - 299px);\r\n  }\r\n}\r\n@media all and (max-width: 1100px) {\r\n  .backDrop {\r\n    position: fixed;\r\n    display: block;\r\n    top: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100vh;\r\n    z-index: 1001;\r\n    background-color: rgba(50, 50, 50, 0.219);\r\n  }\r\n  .openMainContainer {\r\n    /* width: calc(100% - 25px); */\r\n    width: 100%;\r\n  }\r\n}\r\n@media all and (max-width: 400px) {\r\n  .themeSidebarContainer {\r\n    width: calc(100% - 18px);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutContainer": `ThemeLayout_layoutContainer__xTDkL`,
	"rtlDir": `ThemeLayout_rtlDir__mOypM`,
	"ltrDir": `ThemeLayout_ltrDir__Dvwt7`,
	"themeSidebarContainer": `ThemeLayout_themeSidebarContainer__KLqvY`,
	"sidebarContainerRtlLan": `ThemeLayout_sidebarContainerRtlLan__fqE0g`,
	"sidebarContainerLtrLan": `ThemeLayout_sidebarContainerLtrLan__m9Upf`,
	"opSb": `ThemeLayout_opSb__3UXUl`,
	"rtlCl": `ThemeLayout_rtlCl__GFVc-`,
	"ltrCl": `ThemeLayout_ltrCl__LN8v1`,
	"mainContainer": `ThemeLayout_mainContainer__INcS9`,
	"openMainContainer": `ThemeLayout_openMainContainer__YpI8+`,
	"closeMainContainer": `ThemeLayout_closeMainContainer__Bxn6T`,
	"backDrop": `ThemeLayout_backDrop__sBs2r`,
	"privateSwip": `ThemeLayout_privateSwip__ecsMr`,
	"whiteRootBackground": `ThemeLayout_whiteRootBackground__M3Q3W`,
	"pinkRootBackground": `ThemeLayout_pinkRootBackground__R6NBB`,
	"gradientRootBackground": `ThemeLayout_gradientRootBackground__Kuuj7`,
	"darkRootBackground": `ThemeLayout_darkRootBackground__CpY48`,
	"BlueRootBackground": `ThemeLayout_BlueRootBackground__N-QVL`,
	"privateSwipOpen": `ThemeLayout_privateSwipOpen__G2Ss1`,
	"privateSwipClose": `ThemeLayout_privateSwipClose__9x-Sj`,
	"privateSwipBackDrop": `ThemeLayout_privateSwipBackDrop__bkToY`
};
export default ___CSS_LOADER_EXPORT___;
